import type { InputFieldClearButtonData, InputProps } from '..';

export interface InputRangeFieldData {
  limit: [number, number];
  onChange?: (value: [number, number]) => void;
  labelFormatter?: (value: number) => string;
}

export interface InputRangeFieldProps
  extends Omit<InputProps, 'onChange' | 'value'>,
    InputRangeFieldData {
  name: string;
  clearButton?: InputFieldClearButtonData<[number, number]>;
}
